<template>
    <div class="custom-settings-popover">
        <div class="filter-settings filter-settings-wrapper">
            <div class="settings-close" @click="hideFilterSettings">
                ×
            </div>
            <v-bar wrapper="v-bar-filter-settings">
                <div class="subtitle">
                    фильтрация по:
                </div>
                <el-form label-position="top" class="deal-filter-main" @keyup.enter.native="filterApplied">
                    <el-form-item :label="fieldsNames.id" v-if="isColumnVisible('id')">
                        <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.status_id" v-if="isColumnVisible('status_id')">
                        <el-select
                            v-model="filterModel.status_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.status_id"
                            size="mini"
                        >
                            <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.title" v-if="isColumnVisible('title')">
                        <el-input v-model="filterModel.title" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_name" v-if="isColumnVisible('contact_name')">
                        <el-input v-model="filterModel.contact_name" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_phone" v-if="isColumnVisible('contact_phone')">
                        <el-input v-model="filterModel.contact_phone" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.assigned_user_id" v-if="isColumnVisible('assigned_user_id')">
                        <el-select
                            v-model="filterModel.assigned_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.assigned_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in employers" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.planned" v-if="isColumnVisible('planned')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.planned.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.planned.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.related_entity_id" v-if="isColumnVisible('related_entity_id')" type="number">
                        <el-input v-model="filterModel.related_entity_id" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.created_user_id" v-if="isColumnVisible('created_user_id')">
                        <el-select
                            v-model="filterModel.created_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.created_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in employers" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finished" v-if="isColumnVisible('finished')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.finished.min"
                                type="datetime"
                                start-placeholder="дата время"
                                end-placeholder="дата время"
                                clearable
                                format="dd.MM.yyyy HH:mm"
                                value-format="dd.MM.yyyy HH:mm"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.finished.max"
                                type="datetime"
                                start-placeholder="дата время"
                                end-placeholder="дата время"
                                clearable
                                format="dd.MM.yyyy HH:mm"
                                value-format="dd.MM.yyyy HH:mm"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                </el-form>
                <div class="actions-wrapper">
                    <div class="btn btn-default grey" @click="hideFilterSettings">
                        отменить
                    </div>
                    <div class="btn btn-default orange" @click="filterApplied">
                        применить
                    </div>
                </div>
            </v-bar>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus';
import { pickerOptions } from '@/common/pickerOptions';
import VBar from 'v-bar';

export default {
    name: 'TasksListFilterSettingsMobile',
    data() {
        return {
            pickerOptions,
            fieldsNames: {},
            dates: {
                planned: {
                    min: null,
                    max: null
                },
                finished: {
                    min: null,
                    max: null
                }
            },
            dateAttributes: [
                'planned',
                'finished'
            ]
        };
    },
    components: { VBar },
    props: {
        attributes: {
            type: Object,
            default: () => {}
        },
        filter: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        hideFilterSettings() {
            eventBus.$emit('hideFilterSettings');
        },
        filterApplied() {
            this.joinDates();
            this.$emit('filterApplied', this.filterModel);
            this.hideFilterSettings();
        },
        isColumnVisible(colId) {
            return this.attributes[colId].hide === false;
        },
        //собираем даты с промежутками
        joinDates() {
            Object.keys(this.dates).forEach((item) => {
                this.filterModel[item] = null;
                const min = this.dates[item].min;
                const max = this.dates[item].max;
                if (min !== null && max !== null) {
                    this.filterModel[item] = [min, max];
                }
                if (typeof (min) === 'undefined' || typeof (max) === 'undefined') {
                    this.dates[item].min = null;
                    this.dates[item].max = null;
                    this.filterModel[item] = null;
                }
            });
        }
    },
    mounted() {
        Object.keys(this.attributes).forEach((item) => {
            this.$set(this.fieldsNames, item, this.attributes[item].name);
        });

        //начальные значения для дэйтпикеров
        Object.keys(this.dates).forEach((item) => {
            if (this.filter[item] !== null && (typeof this.filter[item] !== 'undefined')) {
                this.dates[item].min = this.filter[item][0];
                this.dates[item].max = this.filter[item][1];
            }
        });
    },
    computed: {
        filterModel() {
            return this.filter;
        },
        status() {
            return this.$store.state.references.taskStatuses;
        },
        employers() {
            return this.$store.state.references.employers;
        }
    }
};
</script>
